export default {
    loader: {
        isLoading: false,
        type: 'full' // 'full', 'container', 'modal'
    },
    master: {
        email: null,
        access: 'MASTER',
        brokerages: [],
        adjudicators: [],
        agents: []
    },
    accounts: {
        list: null,
        currentAccount: {
            meta: null,
            admins: null,
            classes: null,
            divisions: null,
            plan: null,
            designs: {}, // object of classIDs and design data
            pricing: null,
            billing: null,
            employees: null,
            notifications: null,
            modularBlueprints: {},
            invoices: {
                current: null,
                selected: null,
                history: [],
                asoReports: {
                    history: null,
                    balances: null
                }
            },
            revision: null
        },
        forReview: {
            list: null,
            cursor: 0
        },
        cursor: 0
    },
    quotes: {
        all: [], // all quotes for the current advisor
        forReview: {
            cursor: 0,
            list: null
        }, // all quotes pending review
        currentQuote: null // the currently selected quote
    },
    advisors: {
        list: null,
        currentAdvisor: null,
        cursor: 0
    },
    users: {
        list: null,
        currentUser: null,
        claimDetails: null,
        cursor: 0
    },
    adjudication: {
        claimsList: null,
        currentClaim: null,
        claimTypes: null,
        cursor: 0,
        predeterminationsCursor: 0,
        predeterminations: null
    },
    notifications: {
        items: []
    },
    notifier: {
        showing: false,
        verbiage: 'Something failed, please try again',
        type: 'error'
    }
};